<template>
  <div class="card my-4 mx-4">
    <div class="card-header pb-0">
      <h6>Edit Cookie Policy CMS</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="p-3">
        <Form
          as="form"
          @submit="onSubmit"
          class="form"
          :initial-values="initialData"
          :validation-schema="schema"
          v-slot="{ errors }"
          v-if="cookiePolicyObj"
        >
          <div class="form-group row">
            <div class="col-md-6">
              <label for="exampleInputEmail1">Title</label>
              <Field
                name="title"
                type="text"
                class="form-control"
                v-model="cookiePolicyObj.title"
                :class="{ 'is-invalid': errors.title }"
              />
              <div class="invalid-feedback">{{ errors.title }}</div>
            </div>
            <div class="col-md-6">
              <label for="exampleInputEmail1">Arabic Title</label>
              <Field
                name="title_ar"
                type="text"
                class="form-control"
                v-model="cookiePolicyObj.title_ar"
                :class="{ 'is-invalid': errors.title_ar }"
              />
              <div class="invalid-feedback">{{ errors.title_ar }}</div>
            </div>
          </div>
          <div class="form-group my-2">
            <label for="description">Description</label>
            <quill-editor
              v-model:content="cookiePolicyObj.description"
              class="mb-3"
              id="rich-text"
              rows="20"
              ref="quill"
              @change="onChange($event)"
              contentType="html"
            >
            </quill-editor>
          </div>
          <div class="form-group my-2">
            <label for="description_ar">Arabic Description</label>
            <quill-editor
              v-model:content="cookiePolicyObj.description_ar"
              class="mb-3"
              id="rich-text-ar"
              rows="20"
              ref="quill"
              @change="onChangeAR($event)"
            >
            </quill-editor>
          </div>
          <div class="my-4">
            <div class="form-group row">
              <h4>Meta Data</h4>
              <div class="col-md-6">
                <label for="">Meta Title</label>
                <Field
                  name="meta_title"
                  type="text"
                  as="input"
                  class="form-control"
                  v-model="cookiePolicyObj.meta_title"
                  :class="{ 'is-invalid': errors.meta_title }"
                />
                <div class="invalid-feedback">
                  {{ errors.meta_title }}
                </div>
              </div>
              <div class="col-md-6">
                <label for="">Meta Description</label>
                <Field
                  name="meta_description"
                  type="text"
                  as="textarea"
                  class="form-control"
                  v-model="cookiePolicyObj.meta_description"
                  :class="{ 'is-invalid': errors.meta_description }"
                />
                <div class="invalid-feedback">
                  {{ errors.meta_description }}
                </div>
              </div>
              <div class="col-md-6">
                <label for="">Meta Keywords</label>
                <Field
                  name="meta_keywords"
                  type="text"
                  as="textarea"
                  class="form-control"
                  v-model="cookiePolicyObj.meta_keywords"
                  :class="{ 'is-invalid': errors.meta_keywords }"
                />
                <div class="invalid-feedback">
                  {{ errors.meta_keywords }}
                </div>
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-danger my-2">Submit</button>
          <button
            type="button"
            @click="handleCancel"
            class="btn btn-outline-success my-2 cancel-btn"
          >
            Cancel
          </button>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import { Field, Form, useForm } from "vee-validate";
import * as yup from "yup";
import { mapGetters } from "vuex";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import _ from "lodash";
import { quillEditor } from "vue-quill-editor";

export default {
  name: "Cookie Policy",
  components: {
    Form,
    Field,
    quillEditor,
  },

  data() {
    const { setFieldValue } = useForm();
    const schema = yup.object().shape({
      title: yup.string().trim().required("Title is Required"),
      title_ar: yup.string().trim().required("Arabic Title is Required"),
      meta_title: yup.string().trim(),
      meta_description: yup.string().trim(),
      meta_keywords: yup.string().trim(),
    });

    const initialData = {
      title: "",
      title_ar: "",
      meta_title: "",
      meta_description: "",
      meta_keywords: "",
    };

    return {
      description: "",
      description_ar: "",
      meta_title: "",
      meta_description: "",
      meta_keywords: "",
      schema,
      initialData,
      setFieldValue,
    };
  },
  computed: {
    ...mapGetters("cookiePolicy", ["cookiePolicyObj", "isLoading"]),
  },
  async mounted() {
    await this.fetchDetail();
    let initData = this.cookiePolicyObj ? _.clone(this.cookiePolicyObj) : {};
    this.initialData = this.cookiePolicyObj
      ? {
          ...initData,
        }
      : this.initialData;
    this.description = this.cookiePolicyObj.description;
    this.description_ar = this.cookiePolicyObj.description_ar;
    this.meta_title = this.cookiePolicyObj.meta_title;
    this.meta_description = this.cookiePolicyObj.meta_description;
    this.meta_keywords = this.cookiePolicyObj.meta_keywords;
  },
  methods: {
    onChange(event) {
      this.description = event.html;
    },
    onChangeAR(event) {
      this.description_ar = event.html;
    },
    async fetchDetail() {
      try {
        await this.$store.dispatch("cookiePolicy/fetchCookiePolicyDetail", 1);
      } catch (err) {
        console.log(err);
      }
    },
    onSubmit(values) {
      const obj = {
        ...values,
        description: this.description,
        description_ar: this.description_ar,
        meta_title: this.cookiePolicyObj.meta_title,
        meta_description: this.cookiePolicyObj.meta_description,
        meta_keywords: this.cookiePolicyObj.meta_keywords,
      };
      console.log("Submission object:", obj);
      this.$store.dispatch("cookiePolicy/put", obj)
        .then(() => {
          this.$swal({
            position: "center",
            icon: "success",
            title: "Cookie Policy Page has been Updated",
            showConfirmButton: false,
            timer: 2000,
          });
          this.$router.push("/cms");
        })
        .catch(err => {
          console.error("Update failed:", err);
        });
    },
    handleCancel() {
      this.$router.push("/cms");
    },
  },
};
</script>
